import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico_minus_sign_jax_01f499f60697b69361d40ec70faa9078",
  "use": "ico_minus_sign_jax_01f499f60697b69361d40ec70faa9078-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ico_minus_sign_jax_01f499f60697b69361d40ec70faa9078\">\n<path d=\"M0 5.99512H12\" stroke=\"currentColor\" stroke-width=\"2.4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol